const short = require("short-uuid");
const baseModel = require("../baseModel")

/**
 * フォーム設定用のデータ取得モデルクラス
 */
class InspectMasterModel extends baseModel {
  /**
   * テナント内のフォーム設定リストを取得する
   * @param {テナント(グループ)}} tenantId
   * @returns
   */
  static async getInspectMasterList(tenantId) {
    return await super.getList({ beginsWith: `inspectMaster#` }, tenantId)
  }

  /**
   * フォーム設定を削除する
   * @param {pk:テナントID, sk:sk} data
   * @returns
   */
  static async deleteInspectMaster(data) {
    await super.deleteData(data)
  }

  /**
   * フォーム設定レコードを追加する
   * @param {*} data
   */
  static async addInspectMaster(data) {
    await super.addData(data)
  }

  /**
   * フォーム設定レコードを更新する
   * @param {*} data
   */
  static async updateInspectMaster(data) {
    await super.updateData(data)
  }

  /**
   * フォーム設定レコードを取得する
   * @param {*} data
   */
  static async getInspectMaster(sk, tenantId) {
    return await super.getSingleData({sk: sk}, tenantId);
  }

  /**
   * skの文字列を生成
   * @param {*}
   * @returns
   */
  static createSk(id) {
    return `inspectMaster#${id}`;
  }
  /**
   * 新規登録用のスキーマ
   */
  // static async getNewData(projectId) {
  static async getNewData() {
    let newRowData = await super.getNewData()
    
    const id = short.generate()
    newRowData.sk = this.createSk(id)
    
    newRowData.inspectMaster = {
      id: id,
      name: "",
      statusName: "ステータス",
      displayName: "",
      description: "",
      iconSelectType: "1",
      inspectItemList: [],
      iconSetting: [],
      lockFlg: false,
      order: 0
    }

    return newRowData
    
  }
}

module.exports = InspectMasterModel;
